import { useEffect, useState } from "react";
import { Alert, Button, Col, Container, Row } from "react-bootstrap";
import styles from "./alertDismissible.module.css";

function AlertDismissible({
  title = "Alert",
  msg = "Alert msg",
  type = "success",
  showAlert = false,
  onConfirm,
}) {
  const [show, setShow] = useState(showAlert);

  const handleCancel = () => {
    setShow(false);
    if (onConfirm) onConfirm(false);
  };

  const handleConfirm = () => {
    setShow(false);
    if (onConfirm) onConfirm(true);
  };

  useEffect(() => {
    setShow(showAlert);
  }, [showAlert]);

  return (
    <>
      {show && (
        <div className={styles.backdrop}>
          <Container className="h-100 d-flex align-items-center justify-content-center">
            <Row className="w-100 justify-content-center">
              <Col xs={10} sm={8} md={6} lg={6}>
                <div className={styles.alert_main}>
                  <Alert variant={type}>
                    <Alert.Heading>{title}</Alert.Heading>
                    <p>{msg}</p>
                    <hr />
                    <div className="d-flex justify-content-end">
                      <Button onClick={handleConfirm} variant="outline-success">
                        Confirm
                      </Button>
                      <Button
                        onClick={handleCancel}
                        variant="outline-danger"
                        className="ms-2"
                      >
                        Cancel
                      </Button>
                    </div>
                  </Alert>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
}

export default AlertDismissible;
